import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';

function MississippiForm(props) {
  const { version } = props;
  const isVersion2025OrLater = !['5_15', '8_20', '10_22', '11_23'].includes(version);

  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}
export default MississippiForm;
